import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

import { useDark, useToggle } from '@vueuse/core'

interface Preferences {
    isOpen: boolean
    workspaceSwitcher: boolean
    isDarkMode: boolean
    defaultOpeneds: string[]
    organizationBarOpen: boolean
}

export const useLayoutPreferencesStore = defineStore('layoutPreferencesStore', {
    state: () => {
        return {
            preferences: useStorage<Preferences>('layoutPreferences', {
                isOpen: true,
                workspaceSwitcher: true,
                isDarkMode: true,
                defaultOpeneds: [],
                organizationBarOpen: true
            })
        }
    },
    getters: {
        isMenuOpen(state) {
            return state.preferences.isOpen
        },
        isWorkspaceSwitcherEnabled(state) {
            return state.preferences.workspaceSwitcher
        },
        isDarkMode(state) {
            return state.preferences.isDarkMode
        },
        isOrganizationBarOpen(state) {
            return state.preferences.organizationBarOpen
        },
        defaultOpeneds(state) {
            return state.preferences.defaultOpeneds
        }
    },
    actions: {
        menuOpen() {
            this.preferences.isOpen = true
            return this.preferences.isOpen
        },
        menuClose() {
            this.preferences.isOpen = false
            return this.preferences.isOpen
        },
        menuToggle() {
            if (this.preferences.isOpen) {
                return this.menuClose()
            } else {
                return this.menuOpen()
            }
        },
        organizationBarOpen() {
            this.preferences.organizationBarOpen = true
            return this.preferences.organizationBarOpen
        },
        organizationBarClose() {
            this.preferences.organizationBarOpen = false
            return this.preferences.organizationBarOpen
        },
        organizationBarToggle() {
            if (this.preferences.organizationBarOpen) {
                return this.organizationBarClose()
            } else {
                return this.organizationBarOpen()
            }
        },
        showWorkspaceSwitcher() {
            this.preferences.workspaceSwitcher = true
        },
        hidesWorkspaceSwitcher() {
            this.preferences.workspaceSwitcher = false
        },
        workspaceSwitcherToggle() {
            if (this.preferences.workspaceSwitcher) {
                this.hidesWorkspaceSwitcher()
                return
            }
            this.showWorkspaceSwitcher()
        },

        darkModeToggle() {
            if (this.preferences.isDarkMode) {
                this.setDarkMode(false)
            } else {
                this.setDarkMode(true)
            }
        },
        setDarkMode(isDarkMode: boolean) {
            this.preferences.isDarkMode = isDarkMode
        },
        setDefaultOpeneds(defaultOpeneds: string[]) {
            this.preferences.defaultOpeneds = defaultOpeneds
        }
    }
})
